import React from 'react'
import { useInView } from 'react-intersection-observer';
import ImageC1 from './../../images/CapitalOne.png';
import Image1 from './../../images/NG.jpg';
import Image2 from './../../images/AIRIC.PNG';
import Image3 from './../../images/SASE.png';
import ImageGator from './../../images/gator.png';
import ImageCollins from './../../images/collins.png';

import "./Experience.css";

const experiences = [
    {
        image: ImageC1,
        company: "Capital One",
        title: "Senior Associate Software Engineer",
        description: "Working on Card Application Prefill and Government ID Vendor Integrations.",
        date: "Jan 2026 - Present",
    },
    {
        image: ImageC1,
        company: "Capital One",
        title: "Associate Software Engineer",
        description: "Joined as a Technology Development Program (TDP) Associate on the Government ID & Selfie verifications backend team.",
        date: "Aug 2024 - Dec 2025",
    },
    {
        image: ImageCollins,
        company: "Collins Aerospace",
        title: "SWE Intern",
        description: "Worked on hybrid data/software engineering team to deliver data quality and LLM training foundations.",
        date: "May 2023 - Aug 2023",
    },
    {
        image: Image3,
        company: "Society of Asian Scientist and Engineers (SASE)",
        title: "SET Lead/Founder",
        description: "Founded UF SASE's first interdisciplinary design team, the Sase Engineering Team (SET).",
        date: "Aug 2022 - May 2023",
    },
    {
        image: Image1,
        company: "Northrop Grumman",
        title: "SWE Intern",
        description: "Worked on the Cloud Based Engineering team developing DevOps tools and enterprise cloud migrations.",
        date: "June 2022 - Aug 2022",
    },
];

const TimelineCard = ({ exp, index, center }) => {
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });
    const side = center ? "timeline-center" : (index % 2 === 0 ? "timeline-left" : "timeline-right");

    return (
        <div
            ref={ref}
            className={`timeline-item ${side} ${inView ? "show" : ""}`}
        >
            <div className="timeline-dot"></div>
            {exp.date && <span className="timeline-date">{exp.date}</span>}
            <div className="timeline-content">
                <img src={exp.image} alt={exp.company || exp.title} />
                {exp.company && <h4>{exp.company}</h4>}
                <h3>{exp.title}</h3>
                {exp.description && <p>{exp.description}</p>}
            </div>
        </div>
    );
};

const Experiences = () => {
    return (
        <div id="exp" className="exp__section">
            <section>
                <h3 className="exp__title"><b>Experiences</b></h3>
                <div className="ornament"></div>
                <div className="timeline">
                    {experiences.map((exp, i) => (
                        <TimelineCard key={i} exp={exp} index={i} />
                    ))}
                    <TimelineCard
                        exp={{ image: ImageGator, company: "University of Florida", title: "First Generation Student", description: "Started college studying Computer Science in 2020" }}
                        index={experiences.length}
                        center
                    />
                </div>
                <div className="see-more">
                    <h3>Want to see more?</h3>
                    <div className="see-more-buttons">
                        <a className="see-btn" href="#Projects">My Work</a>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Experiences;
